import { render } from "./preloader_page.vue?vue&type=template&id=45831c56&scoped=true"
import script from "./preloader_page.vue?vue&type=script&lang=js"
export * from "./preloader_page.vue?vue&type=script&lang=js"

import "./preloader_page.vue?vue&type=style&index=0&id=45831c56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45831c56"]])

export default __exports__